// src/features/participants/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import PolicyHolder from './pages/policyHolder/PolicyHolder';
import PolicyHolderForm from './pages/policyHolder/PolicyHolderForm';
import Company from './pages/company/Company';
import CompanyForm from './pages/company/CompanyForm';
import PolicyHolderBulkForm from './pages/policyHolder/PolicyHolderBulkForm';
import DependentForm from './pages/policyHolder/DependentForm';
import Detail from './pages/company/Detail';
import PolicyHolderDetailForm from './pages/policyHolder/PolicyHolderDetailForm';
import UserForm from './pages/company/UserForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';
import Profile from './pages/policyHolder/Profile';
import Exceptions from './pages/company/exceptions/Exceptions';
import ExceptionForm from './pages/company/exceptions/ExceptionForm';
import CompanyService from './pages/company/CompanyService';


export const participantsRoute = createRoute({
  getParentRoute: () => rootRoute,
    path: '/participants',
});

export const participantsPolicyHolderRoute = createRoute({
  getParentRoute: () => participantsRoute,
    path: '/policy-holder',
    component: PolicyHolder,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SEARCH_POLICYHOLDER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsPolicyHolderProfileRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/profile',
    component: Profile,
});

export const participantsPolicyHolderFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/policy-holder/form',
    component: PolicyHolderForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SAVE_POLICYHOLDER || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

 export const participantsPolicyHolderBulkFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/policy-holder/bulkForm',
     component: PolicyHolderBulkForm,
     beforeLoad: () => {
         if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SAVE_BULK_POLICYHOLDER || ""))) {
             // eslint-disable-next-line @typescript-eslint/no-explicit-any
             throw redirect({ to: '/not-authorized' as any });
             //console.log('permission denied');
         }
     },
});
 export const participantsPolicyHolderBulkDetailFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
     path: '/policy-holder/Detail',
     component: PolicyHolderDetailForm,
     beforeLoad: () => {
         if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.GET_POLICYHOLDER_BY_DETAIL || ""))) {
             // eslint-disable-next-line @typescript-eslint/no-explicit-any
             throw redirect({ to: '/not-authorized' as any });
             //console.log('permission denied');
         }
     },
});



export const participantsCompanyRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company',
    component: Company,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SEARCH_COMPANY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsCompanyDetailRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company/Detail',
    component: Detail,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.GET_COMPANY_BY_DETAIL || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsCompanyFormFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company/form',
    component: CompanyForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SAVE_COMPANY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsCompanyExceptionRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company/exceptions',
    component: Exceptions,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.EXCEPTIONS.SEARCH || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsCompanyExceptionFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company/exceptions/form',
    component: ExceptionForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.EXCEPTIONS.SAVE || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const participantsCompanyServiceRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/company/service',
    component: CompanyService,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SEARCH_COMPANY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
        }
    },
});


export const dependentFormRoute = createRoute({
    getParentRoute: () => participantsRoute,
    path: '/policy-holder/DependentForm',
    component: DependentForm,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.PARTICIPANTS.SAVE_POLICYHOLDER_DEPENDENT || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const customerUserFormRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/participants/company/detail/user',
    component: UserForm,
});

export const participantsRoutes = [
    participantsRoute,
    participantsPolicyHolderRoute,
    participantsPolicyHolderProfileRoute,
    participantsPolicyHolderFormRoute,
    participantsCompanyRoute,
    participantsCompanyFormFormRoute,
    participantsPolicyHolderBulkFormRoute,
    participantsPolicyHolderBulkDetailFormRoute,
    dependentFormRoute,
    participantsCompanyDetailRoute,
    customerUserFormRoute,
    participantsCompanyExceptionRoute,
    participantsCompanyExceptionFormRoute,
    participantsCompanyServiceRoute
];